import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Icon, Table, TableColumnOpcoes, TableSearch } from '@components';
import { deleteNotificacaoEmail, getNotificacaoEmails } from '@ducks/conectoresNotificacao';

export default function TableNotificacao() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [st1, setSt1] = useState('');
  const [st2, setSt2] = useState('');

  const emails = useSelector(({ conectoresNotificacao }) => conectoresNotificacao.get('emails').toArray());
  const loadingNotificacaoEmails = useSelector(({ conectoresNotificacao }) => conectoresNotificacao.get('loadingNotificacaoEmails'));

  const handleSearch = () => {
    dispatch(getNotificacaoEmails());
  };

  const handleDeleteNotificacao = (id) => {
    dispatch(deleteNotificacaoEmail(id));
  };

  useEffect(() => {
    handleSearch();
  }, []);

  const columns = [
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      width: '85%',
      ...TableSearch('email', 'email', { st1, setSt1, st2, setSt2 }),
    },
    {
      title: 'Opções',
      dataIndex: 'id',
      key: 'options',
      align: 'right',
      width: '15%',
      render: (text) => (
        <TableColumnOpcoes>
          <Icon.Edit action={() => history.push(`/conectores/notificacao/email/${text}`)} />
          <Icon.Delete popConfirmTitle={'Deseja excluir a configuração de notificação?'} action={() => handleDeleteNotificacao(text)} />
        </TableColumnOpcoes>
      ),
    },
  ];

  return <Table rowKey='id' columns={columns} dataSource={emails} loading={loadingNotificacaoEmails} hidePagination />;
}
